import { useQuery } from '@tanstack/react-query';
import usersService, {
  UsersSearchParams,
  UsersSearchResponse,
} from '~/services/usersService/users.service';

export const useUsers = (params: UsersSearchParams) => {
  const { searchQuery = '' } = params;
  const isSearchEnabled = !searchQuery || searchQuery.length >= 3;

  const { data, isLoading, error } = useQuery<UsersSearchResponse | null>({
    queryKey: ['users', 'search', params],
    queryFn: () => usersService.searchUsers(params),
    enabled: isSearchEnabled,
    staleTime: 1000 * 60, // Cache for 1 minute
  });

  return {
    users: data?.users || [],
    totalCount: data?.total || 0,
    isLoading: isLoading && isSearchEnabled,
    error,
  };
};
